/*
 *
 * StudentsDetail constants
 *
 */

export const FLUSH_STATE = 'app/StudentsDetail/FLUSH_STATE';

export const LOAD_STUDENT = 'app/StudentsDetail/LOAD_STUDENT';
export const LOAD_STUDENT_SUCCESS = 'app/StudentsDetail/LOAD_STUDENT_SUCCESS';
export const LOAD_STUDENT_ERROR = 'app/StudentsDetail/LOAD_STUDENT_ERROR';

export const CHANGE_STUDENT = 'app/StudentsDetail/CHANGE_STUDENT_DATA';
export const CHANGE_STUDENT_SUCCESS =
  'app/StudentsDetail/CHANGE_STUDENT_SUCCESS';
export const CHANGE_STUDENT_ERROR = 'app/StudentsDetail/CHANGE_STUDENT_ERROR';
